<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { useRequestStore } from '@/stores/request';
import { useOptionsStore } from '@/stores/options';
import { storeToRefs } from 'pinia';

const props = defineProps({
    request: {
        type: Object,
        required: true
    }
});

const emit = defineEmits(['close-modal', 'cancel-modal']);

const { binOptions } = storeToRefs(useOptionsStore());
const { completeRequest } = useRequestStore();

const form = ref({
    bin_id: null,
});

const save = async () => {
    try {
        await completeRequest({
            hash: props.request.hash,
            bin_id: form.value.bin_id,
        });
        emit('close-modal');
    } catch (error) {
        // The response interceptor surfaces the error toast
    }
};
</script>
<template>
<ModalWrapper @cancel-modal="emit('cancel-modal')">
    <template #header>{{ $t('label.complete') }} {{ $t('label.request') }}</template>
    <template #subheader>{{ request.reference }}</template>

    <form @submit.prevent="save">
        <dl class="space-y-2 text-sm mb-4">
            <div class="flex justify-between">
                <dt class="text-ink-light">{{ $t('label.customer') }}</dt>
                <dd class="font-medium">{{ request.customer_name }}</dd>
            </div>
            <div class="flex justify-between">
                <dt class="text-ink-light">{{ $t('label.tire_set') }}</dt>
                <dd class="font-mono text-xs">{{ request.set_barcode }}</dd>
            </div>
            <div class="flex justify-between">
                <dt class="text-ink-light">{{ $t('label.type') }}</dt>
                <dd>
                    <StatusChip :color="request.type === 'to_storage' ? 'winter' : 'summer'">
                        {{ request.type === 'to_storage' ? $t('label.to_storage') : $t('label.from_storage') }}
                    </StatusChip>
                </dd>
            </div>
        </dl>

        <StyledDropdown
            v-if="request.type === 'to_storage'"
            v-model="form.bin_id"
            :options="binOptions"
            name="bin_id"
            :label="$t('label.select_bin')"
            :placeholder="$t('label.select_bin')" />
    </form>

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
